<template>
  <el-row :gutter="15">
    <el-col :sm="24" :md="14" :lg="15" class="mb-lg-10">
      <div
        class="card card-lift bg-defaultnew shadow border-0"
        v-if="currentNews"
      >
        <el-carousel trigger="hover" height="287px" @change="carouselChange">
          <el-carousel-item v-for="item in lastNews" :key="item.id">
            <img
              :src="`https://www.prokuratura.uz/api/download/${item.titleImage}`"
              class="card-img-top"
            />
          </el-carousel-item>
        </el-carousel>
        <blockquote class="card-blockquote">
          <router-link :to="`/newsview?id=${currentNews.id}`">
            <div class="time_info_news">
              <span>{{ parseDate(currentNews.createdDate) }}</span>
              <hr />
              <span v-if="$i18n.locale === 'uz-UZ' || $i18n.locale === 'uz-QR'">{{
                resolveUzQrValue(currentNews.category, ["nameQrq", "nameUzQr"], "nameUzLat")
              }}</span>
              <span v-if="$i18n.locale === 'uz-CYR'">{{
                currentNews.category.nameUz
              }}</span>
              <span v-if="$i18n.locale === 'ru-RU'">{{
                currentNews.category.nameRu
              }}</span>
              <span v-if="$i18n.locale === 'en-US'">{{
                currentNews.category.nameEn
              }}</span>
            </div>
            <h4 class="display-3 text-titlecolor title_text_slider">
              <span v-if="$i18n.locale === 'uz-UZ' || $i18n.locale === 'uz-QR'">{{
                resolveUzQrValue(currentNews, ["titleQrq", "titleUzQr"], "titleUzLat")
              }}</span>
              <span v-if="$i18n.locale === 'uz-CYR'">{{
                currentNews.titleUz
              }}</span>
              <span v-if="$i18n.locale === 'ru-RU'">{{
                currentNews.tilteRu
              }}</span>
              <span v-if="$i18n.locale === 'en-US'">{{
                currentNews.titleEn
              }}</span>
            </h4>
          </router-link>
        </blockquote>
      </div>
      <div class="mt_new-1">
        <h5 class="card_new_title_shadow mb-2">
          {{ $t("homepage.interactive") }}
        </h5>
        <el-row :gutter="10">
          <!--                    <el-col :sm="12" :md="12" :lg="6" class="mb-3 mb-lg-10">-->
          <!--                        <router-link to="/gender_equality">-->
          <!--                            <div class="card card-lift shadow border-0 card-img_tab_card_min">-->
          <!--                                <img v-lazy="'img/strategy/gender_equality.svg'" class="image_card_icon_min">-->
          <!--                                <span class="card_new_span_wt vertical-center">{{$t('homepage.gender_equality')}}</span>-->
          <!--                            </div>-->
          <!--                        </router-link>-->
          <!--                    </el-col>-->
          <!--                    <el-col :sm="12" :md="12" :lg="6" class="mb-3 mb-lg-10">-->
          <!--                        <router-link to="/murojaat_monitoring">-->
          <!--                            <div class="card card-lift shadow border-0 card-img_tab_card_min">-->
          <!--                                <img v-lazy="'img/strategy/file.svg'" class="image_card_icon_min">-->
          <!--                                <span class="card_new_span_wt vertical-center">{{$t('homepage.monitor')}}</span>-->
          <!--                            </div>-->
          <!--                        </router-link>-->
          <!--                    </el-col>-->
          <el-col :sm="12" :md="12" :lg="12" class="mb-3 mb-lg-10">
            <router-link to="/aliment">
              <div class="card card-lift shadow border-0 card-img_tab_card_min">
                <img
                  v-lazy="'img/strategy/calculator.svg'"
                  class="image_card_icon_min"
                />
                <span class="card_new_span_wtinter vertical-center">{{
                  $t("homepage.aliment")
                }}</span>
              </div>
            </router-link>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12" class="mb-3 mb-lg-10">
            <router-link to="/ozodmuddat">
              <div class="card card-lift shadow border-0 card-img_tab_card_min">
                <img
                  v-lazy="'img/strategy/calendar.svg'"
                  class="image_card_icon_min"
                />
                <span class="card_new_span_wtinter vertical-center">{{
                  $t("homepage.ozod")
                }}</span>
              </div>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <div class="mb-3">
        <h5 class="card_new_title_shadow mb-2">{{ $t("homepage.photo") }}</h5>
        <el-carousel trigger="click" height="135px">
          <el-carousel-item
            v-for="(item, index) in getImageToSlider(images)"
            :key="'item_' + index"
          >
            <el-row :gutter="10">
              <el-col
                :sm="12"
                :md="12"
                :lg="8"
                class="mb-3 mb-lg-10"
                v-for="(chItem, chIndex) in item"
                :key="'chItem_' + chIndex"
              >
                <router-link to="/">
                  <div class="card card-lift shadow border-0">
                    <img v-lazy="chItem" class="card-img" />
                  </div>
                </router-link>
              </el-col>
              <!--
                            <el-col :sm="12" :md="12" :lg="8" class="mb-3 mb-lg-10">
                                <router-link to="/">
                                    <div class="card card-lift shadow border-0">
                                        <img v-lazy="'img/gallery/rasm1.jpg'" class="card-img">
                                    </div>
                                </router-link>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8" class="mb-3 mb-lg-10">
                                <router-link to="/">
                                    <div class="card card-lift shadow border-0">
                                        <img v-lazy="'img/gallery/rasm2.jpg'" class="card-img">
                                    </div>
                                </router-link>
                            </el-col>-->
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="mb-3">
        <h5 class="card_new_title_shadow mb-2">
          {{ $t("homepage.prokuratura") }}
        </h5>
        <el-row :gutter="10">
          <template
            v-if="
              selectedRegion && selectedRegion > 0 && regionData[selectedRegion]
            "
          >
            <el-col :sm="24" :md="24" :lg="12" class="mb-3 mb-lg-10">
              <el-row :gutter="10" style="height: 196px; overflow: auto;">
                <el-col
                  :sm="12"
                  :md="12"
                  :lg="12"
                  class="mb-3 mb-lg-10"
                  v-for="(item, index) of regionData[selectedRegion]"
                  :key="`regionData-${index}`"
                >
                  <div
                    class="card card-lift bg-defaultmap_info shadow border-0"
                  >
                    <router-link to="/">
                      <img :src="item['photo']" class="card-img-map_info" />
                      <blockquote class="card-blockquote map_block_info">
                        <span class="display-1 text-mapcolor title_map_text"
                          ><strong>{{ $t("homepage.phone") }} </strong
                          >{{ item["tel"] }}</span
                        >
                        <!--                        <span class="display-1 text-mapcolor title_map_text"-->
                        <!--                          ><strong>{{ $t("homepage.fax") }} </strong-->
                        <!--                          >{{ item["fax"] }}</span-->
                        <!--                        >-->
                        <span class="display-1 text-mapcolor title_map_text"
                          ><strong>{{ $t("homepage.address") }} </strong
                          >{{ $t(item["address"]) }}</span
                        >
                        <!--                        <span class="display-1 text-mapcolor title_map_text"-->
                        <!--                          ><strong>{{ $t("homepage.region") }} </strong-->
                        <!--                          >{{ item["orientir"] }}</span-->
                        <!--                        >-->
                      </blockquote>
                    </router-link>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </template>
          <el-col
            :sm="24"
            :md="24"
            :lg="12"
            class="mb-3 mb-lg-10"
            style="float: right;"
          >
            <div class="card card-lift bg-defaultmap_uzb shadow border-0">
              <router-link to="/">
                <blockquote class="card-blockquote map_block_uzb">
                  <div style="width: 100%;">
                    <span
                      class="map_block_text"
                      v-if="
                        selectedRegion &&
                          selectedRegion > 0 &&
                          regionCodes[selectedRegion]
                      "
                      >{{ regionCodes[selectedRegion] }}</span
                    >
                    <svg
                      version="1.1"
                      id="Layer_1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 792 532"
                      style="enable-background:new 0 0 792 532; height: 188px;"
                      xml:space="preserve"
                    >
                      <radialGradient
                        id="SVGID_2_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([26])"
                        :class="{ active: selectedRegion === 26 }"
                        class="st1"
                        d="M750.1,321.55L749.99,317.94L749.68,317.1L745.67,315.82L743.42,315.37L743.18,315.54L742.85,315.54L733.6,313.97L731.36,310.51L730.74,309.86L727.72,308.3L723.56,307.7L723.36,309.15L720.33,304.67L720.33,304.67L722.23,303.46L720.03,300.79L722.06,298.89L723.25,298.09L731.84,295.9L735.52,295.93L736.09,296.19L736.82,296.75L740.15,297.49L741.61,297.64L746.49,297.2L747.02,296.93L747.42,296.48L748.68,290.61L748.68,290.61L748.92,290.76L749.59,290.75L752.44,289.4L753.2,289.22L754.42,288.3L755.55,287.06L756.24,286.99L756.39,287.17L757.71,287.52L758.68,288.2L759.57,288.25L760.36,288.65L761.22,288.56L762,288.73L762.66,289.05L762.92,290.22L762.82,290.87L762,292.39L762.01,292.61L762.19,292.83L762.34,292.81L762.8,292.09L763.03,292.04L763.27,292.01L763.74,292.25L764.16,292.64L765.48,294.9L766.06,295.59L766.26,297.59L767.03,298.14L768.23,298.49L769.56,299.14L771.13,299.72L771.68,299.52L773.5,299.81L774.44,299.41L775.36,299.22L776.04,299.43L778.25,298.87L778.97,298.89L779.79,299.34L781.31,301.01L781.69,302.06L781.86,302.21L782.52,302.37L783.03,302.33L783.68,302.08L783.87,301.78L784.51,301.45L784.91,300.97L785.49,300.95L785.84,300.74L785.69,300.2L785.11,299.8L784.76,299.31L785.19,297.89L785.42,297.66L785.85,297.67L786.86,299.13L787.76,299.33L788.89,300.09L789.84,299.57L791.34,299.64L791.77,300.02L792,300.99L791.57,302.73L791.14,303.34L790.69,303.65L787.81,304.86L786.15,305.1L785.52,305.97L784.36,306.77L782.96,307.55L782.15,307.72L782.1,307.95L781.23,308.15L779.89,308.89L778.89,309.85L777.35,310.35L776.22,310.2L775.43,310.31L775.12,310.67L775.07,310.99L775.21,311.43L775.59,311.89L775.62,312.23L774.88,312.84L774.78,313.26L774.96,316L774.89,317.07L774.24,317.28L773.72,316.98L772.76,316L771.26,315.66L770.94,316.03L770.89,316.79L770.02,317.42L769.88,317.66L769.67,319.06L769.09,320.13L768.42,320.29L768,320.25L766.61,319.13L765.14,319.06L764.45,318.68L763.54,317.81L763.03,317.63L762.35,317.92L762.14,317.88L760.77,316.21L760.22,315.21L758.83,314.04L758.43,313.85L757.45,314.28L756.35,314.29L755.95,314.83L756.1,315.11L757.22,315.49L757.54,315.8L758,316.83L759.05,317.15L759.46,317.71L759.42,318.26L759.07,318.66L758.04,318.76L757.77,318.95L757.6,319.46L757.74,319.91L758.82,319.8L759.08,320.17L759.31,321.64L759.8,322.17L760.04,322.92L758.9,325.59L759.18,326.42L759.11,327.06L758.94,327.22L758.64,327.28L757.16,326.9L756.71,326.63L755.16,325.03L754.51,324.57L754.22,324.47L753.42,324.77L753.1,324.56L752.6,323.85L752.31,323.64L751.41,323.65L751.14,323.54L750.96,323.14L751.29,322.01L751.23,321.76L750.78,321.49z"
                      />
                      <radialGradient
                        id="SVGID_3_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([27])"
                        :class="{ active: selectedRegion === 27 }"
                        class="st1"
                        d="M421.03,384.51L417.26,388.1L413.91,390.32L413.34,390.43L408.94,395.14L408.59,396.17L408.74,397.03L409.45,398.23L410.28,399.11L411.1,400.28L411.33,400.79L411.05,401.4L392.93,408.04L387.32,414.27L387.32,414.27L385.19,411.97L384.78,411.94L383.6,412.24L381.5,413.45L380.5,413.71L379.45,413.73L378.07,413.55L377.22,413.13L374.27,410.7L371.4,408.7L364.61,403.48L362.79,402.31L358.11,398.87L356.8,397.58L355.65,396.19L355.36,395.56L354.95,395.19L354.17,393.96L350.6,390.5L348.58,388.35L344.61,385.54L340.23,382.92L335.78,379.77L331.54,376.99L321.28,369.69L314.32,364.92L299.99,354.39L298.81,353.29L297.9,352L297.74,351.47L297.54,350.57L297.6,350.02L297.31,349.32L297.18,347.57L295.77,345.5L295.79,344.85L296.48,343.66L296.56,341.03L296.18,340.02L296.04,338.79L295.45,336.75L295.39,335.61L295.16,334.84L295.2,334.24L295.56,333.33L295.53,332.32L294.78,330.98L293.62,329.93L292.9,328.87L292.84,328.36L293.34,326.82L293.63,325.35L293.59,325.04L292.27,324.52L290.95,323.68L289.63,322.23L288.36,321.66L287.04,320.79L286.64,320.23L286.64,320.23L292.92,312.62L297.51,307.49L298.3,303.69L298.33,302.15L297.65,301L291.74,294.32L288.5,290.99L288.5,290.99L299.44,285.93L285.66,266.75L285.66,266.75L286.22,266.47L289.89,265.55L303.44,262.34L304.49,262.26L307.83,268.96L309.22,271.02L311.37,273.34L313.76,274.89L317.3,276.79L318.87,278.37L320.95,282.72L322.35,287.87L322.92,289.26L323.8,289.17L324.25,288.8L326.29,288.75L329.45,289.66L334.83,291.97L343.31,296.57L353.14,302.27L355.26,303.94L355.82,304.99L356.16,306.48L355.68,308.71L359.08,308.62L361.72,308.39L362.27,308.2L367.65,296.01L368.69,294.92L370.88,293.75L371.76,293.9L373.43,295.83L373.53,303.44L389.72,305.33L389.91,304.84L390.73,300.35L391.3,300.16L396.32,299.58L400.11,299.52L402.38,299.14L403.51,296.46L404.23,294.36L404.68,294.17L405.65,294.39L406.44,297.22L408.58,307.34L409.72,308.44L410.52,308.86L411.55,309.2L420.18,310.39L426.11,311.02L434.08,312.16L432.68,321.42L428.69,324.23L428.52,325.26L427.07,329.39L423.72,333.53L423.08,334.14L422.14,334.52L418.29,334.29L415.39,333.75L413.38,332.76L412.56,331.97L410.56,330.67L408.5,330.55L407.39,331.03L407.03,331.65L407.39,334.97L406.94,339.33L405.65,345.04L403.12,349.82L400.99,352.29L396.59,354.96L395.7,355.29L394.28,358.01L398.55,363.8L399.74,364.95L406.8,367.62L407.88,367.68L411.08,366.9L415.99,370.59L420.38,379.98L420.74,381.13z"
                      />
                      <radialGradient
                        id="SVGID_4_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([38])"
                        :class="{ active: selectedRegion === 38 }"
                        class="st1"
                        d="M673.54,332.5L673.64,331.84L673.41,331.29L672.67,330.63L669.76,329.32L668.13,328.99L667.13,328.59L666.81,328.59L665.91,329.02L665.48,328.99L665.02,328.78L664.69,328.41L664.23,327.3L663.94,326.99L663.66,326.89L663.51,326.15L662.6,324.38L662.54,323.77L662.67,323.57L663.48,323.35L664.48,322.54L665.67,322.32L666.77,321.75L668.82,321.03L669.62,321.03L670.09,320.62L670.21,319.81L670.65,319.37L670.79,318.48L670.98,318.08L671.38,317.86L671.97,317.78L672.74,317.85L673.22,317.49L673.94,317.47L674.37,317.31L675.24,316.2L676.35,313.98L676.71,313.6L677.36,313.42L678.04,312.69L678.55,312.52L678.7,312.24L679.11,312.16L679.52,311.66L680.49,311.44L680.89,311.72L681.21,311.75L681.26,311.09L681.08,310.1L681.39,309.87L681.67,310.12L682.33,310.08L682.77,309.5L683.07,308.5L683.65,307.97L683.71,307.71L683.71,307.71L684.05,307.62L684.31,307.36L689.18,306.11L692.55,305.5L699.31,305.4L699.31,305.62L698.94,306.14L697.58,307.8L698.41,309.77L700.28,311.63L705.87,314.36L706.27,314.44L707.02,314.02L710.04,311.17L710.8,310.18L711.54,308.73L712.78,307.93L716.89,305.7L720.33,304.67L720.33,304.67L723.36,309.15L723.56,307.7L727.72,308.3L730.74,309.86L731.36,310.51L733.6,313.97L742.85,315.54L743.18,315.54L743.42,315.37L745.67,315.82L749.68,317.1L749.99,317.94L750.1,321.55L750.1,321.55L749.61,321.59L748.54,321.33L748.15,321.41L747.64,322.79L747.34,323.29L746.71,323.89L746.25,324.13L745.88,324.2L745.29,324L744.4,323.41L743.94,324.45L744.39,326.16L744.25,326.5L743.61,327.21L743.54,327.78L743.25,328.18L741.88,328.59L740.84,329.93L740.33,330.31L739.53,331.44L738.34,331.96L737.41,332.82L737.29,333.08L737.5,333.58L738.48,333.81L739.46,334.7L739.39,335.19L738.28,336.22L737.82,337.3L737.53,337.62L736.87,337.95L736.25,337.93L734.98,337.01L732.96,336.54L732.48,336.93L732.35,337.41L732.4,337.68L733.14,338.81L733.16,339.34L732.41,339.84L731.87,339.81L729.38,341.4L728.06,341.82L727.14,342.48L726.79,342.54L726.54,342.4L726.08,341.55L725.65,341.04L725.41,340.97L725.05,340.57L724.9,340.21L725.07,338.31L724.88,337.5L724.2,336.59L723.68,336.23L722.91,336.15L721.68,336.27L721.57,337.11L721.81,338.54L721.6,339.49L721.68,340.05L721.56,340.25L721.27,340.22L720.46,339.26L719.46,339.26L718.91,339.45L717.99,338.87L716.22,338.08L716,337.54L716.19,336.19L715.95,335.67L714.65,335.64L713.11,335.24L712.48,334.74L711.39,333.51L710.98,333.24L710.49,333.09L709.99,333.31L709.37,333.37L709.21,333.06L709.3,332.67L708.98,332.42L707.45,333.06L706.7,333.16L706.43,333.06L706.28,332.79L706.26,331.79L704.72,331.9L703.71,331.56L702.71,331.47L701.88,331.58L700.5,332.04L699.52,332.02L698.91,332.23L696.35,334.01L694.4,334.36L692.33,335.26L691.88,335.55L691.74,335.82L692.05,336.74L691.94,337.71L689.56,337.78L687.61,338.13L687.34,338.04L685.64,339.3L683.17,340.4L681.59,340.73L680.19,340.85L677.06,341.54L676.23,341.2L675.05,339.06L674.73,338.18L674.01,337.79L673.48,336.85L673.61,336.74L673.68,335.46L674.05,334.47L673.5,332.72z"
                      />
                      <radialGradient
                        id="SVGID_5_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([28])"
                        :class="{ active: selectedRegion === 28 }"
                        class="st1"
                        d="M580.4,375.84L579.92,376.09L579.71,377.63L579.39,378.65L578.57,379.38L577.49,379L576.34,379.26L573.38,378.79L571.52,379.6L571.13,379.48L570.34,378.72L569.83,378.48L568.41,378.16L566.64,377.95L565.38,378.09L564.45,378.35L563.71,378.22L562.69,377.63L561.95,377.73L559.72,377.57L558.75,377.09L558.01,376.9L556.92,376.99L556.32,376.84L555.22,375.99L554.31,375.62L552.94,375.54L552.02,375.64L550.15,374.8L549.19,373.92L547.81,373.84L545.38,372.19L544.68,372.58L543.47,372.9L541.54,372.07L541.14,372.06L540.26,373.08L539.17,373.46L538.53,373.91L537.59,375.44L537.01,375.6L535.58,375.63L531.6,377.12L531.48,377.8L531.68,379.41L531.27,379.92L529.05,379.37L528.59,379.48L528.24,380.28L528.22,381.59L528.54,382.1L528.54,382.1L524.01,378.28L522.98,377.23L522.33,376.27L522.12,375.32L522.1,371.16L522.2,370.79L525.42,365.55L526.18,364.64L526.87,364.1L529.03,363.07L530.57,362.69L531.87,362.54L531.79,361.52L530.72,355.56L530.51,355.32L518.64,352.79L513.83,352.39L511.71,351.59L505.88,347.66L505.53,343.95L505.63,343.6L506.87,343.31L507.11,343.15L507.56,341.81L507.63,341L506.19,338.19L504.33,336.53L503.49,332.43L503.39,328.5L503.53,327.73L504.36,325.9L504.35,324.8L503.39,322.62L498.78,322.52L490.99,321.6L490.99,321.6L491.72,319.81L496.15,311.22L499.27,305.9L499.55,305.16L497.98,298.3L497.75,297.77L497.5,297.54L493.23,296.49L492.28,295.91L491.56,294.64L490.43,284L497.14,283.78L497.43,280.85L497.65,280.89L498.17,276.13L498.17,276.13L515.57,277.44L520.21,277.96L522.93,277.97L523.78,278.53L524.65,278.66L525.9,278.25L527.17,278.05L542.58,278.52L543.99,279.81L544.86,280.04L546.91,282.53L550.23,285.61L551.7,284.31L552.54,285.5L555.59,283.52L556.97,284.81L557.56,284.55L558.35,285.02L555.88,285.55L554.47,287.03L555.86,290.48L554.38,291.95L554.46,297.17L550.39,297.32L549.66,299.6L551.1,301.6L553.54,302.28L559.31,305.68L562.9,309.71L566.69,311.05L567.13,311.43L567.13,311.43L566.96,314.27L566.62,314.88L564.76,314.78L562.66,315.32L562.18,320.21L562.34,320.48L564.45,319.46L564.78,319.36L564.94,319.56L564.79,320.33L564.02,322.33L559.07,333.37L558.87,334.89L559.02,335.85L559.36,336.75L560.02,337.72L560.34,337.77L566.89,338.08L571.46,337.91L575.48,337.09L577.76,336.3L584.89,334.66L585.2,335.34L584.19,341.75L584.19,341.75L582.64,342.03L582.55,342.17L579.66,343.01L579.42,343.61L580.28,344.41L582.9,345.95L584.13,345.92L586.28,345.47L587.59,344.91L590.46,344.1L591.69,343.55L595.12,342.66L596.8,342.45L599.95,342.34L600.79,342.99L601.2,344.27L601.65,346.65L601.33,347.31L600.58,347.37L599.05,347.01L598.15,347L597.4,347.03L595.88,347.38L594.71,348.26L594.5,349.3L594.35,349.42L593.89,349.16L593.59,347.87L592.86,346.77L592.21,346.67L591.63,346.87L591.39,347.15L591.36,347.68L591.71,348.25L592.65,349.19L592.7,349.82L592.29,351.17L592.32,351.47L593.82,352.87L596.43,356.11L596.97,357.21L597.01,357.96L596.81,358.65L596.1,359.37L595.29,359.47L594.67,359.16L594.07,358.22L594,356.44L592.65,353.23L591.93,352.35L591.53,352.28L591.06,352.5L590.94,352.9L591.02,354L592.06,355.98L592.87,357.9L592.9,358.59L592.54,359.39L592.18,359.66L591.26,359.87L590.96,360.26L590.69,361.69L590.45,361.91L589.99,362.02L589.43,361.6L589.12,360.33L588.34,359.44L587.88,359.31L586.41,360.54L585.9,360.24L584.7,360.09L584.61,361.24L584.91,362.91L584.59,364.22L584.1,365.07L583.85,365.99L583.55,366.55L582.91,366.82L582.28,366.86L581.86,367.37L582.13,368.01L584.01,370.69L583.74,372.41L581.37,375.09z"
                      />
                      <radialGradient
                        id="SVGID_6_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([32])"
                        :class="{ active: selectedRegion === 32 }"
                        class="st1"
                        d="M749.08,282.29l-0.5,-0.84l-0.46,-0.29l-0.45,-0.07l-0.45,0.24l-1.05,-0.35l-0.76,-0.03l-1.88,1.36l-0.35,0.08l-0.68,-0.3l-1.74,-1.12l-1.14,-0.31l-1.22,-0.14l-1.16,0.79l-0.46,-0.22l-0.56,-0.05l-1.62,-0.65l-0.32,-0.41l0.02,-0.88l-0.56,-0.06l-0.37,-0.2l-0.07,-0.21l0.64,-2l0.92,-1.61l0.78,-0.8l0.47,-0.82l0.56,-1.35l-0.05,-0.25l-1.08,-0.58l-0.85,-1.03l-0.28,-0.65l0.13,-1.3l-0.14,-0.37l-0.38,-0.28l-0.41,0.24l-0.34,0.56l-0.81,0.17l-0.25,-0.17l-0.06,-0.19l0.26,-1.3l-0.62,-1.06l-1.4,-1.35l-1.05,-2.21l-0.37,-0.1l-0.14,0.12l-0.11,1.69l-0.17,0.26l-0.31,0.07l-0.21,-0.41l-0.1,-0.68l-0.31,-0.27l-0.38,-0.03l-0.63,0.45l-0.12,0.4l0.41,0.66l-0.06,0.56l-0.27,0.21l-0.42,-0.26l-0.41,-0.71l-0.1,-0.46l0.09,-0.43l0.84,-1.1l0.46,-0.83l0.07,-0.47l-0.24,-1.41l0.13,-0.3l-0.06,-0.74l0.43,-0.9l-0.35,-0.61l-1.14,-0.05l-0.36,0.1l-0.77,0.72l-0.76,1.36l-0.44,0.5l-1.26,0.43l-0.24,0.35l0.05,0.42l0.32,0.24l1.14,0.11l0.57,0.23l0.5,0.78l0.13,0.68l-0.34,1.22l-0.44,0.81l-0.04,0.41l0.8,1.23l-0.29,0.66l-0.66,0.72l-0.36,0.7l-0.27,0.98l-0.22,0.01l-0.36,-0.25l-0.26,0.25l-0.32,0.72l-0.6,0.49l-0.17,0.58l-0.17,0.04l-0.25,0.95l-0.38,0.32l-0.6,-0.16l-0.61,-0.69l-0.4,-0.22l-0.88,-0.02l-0.42,0.35l-0.67,0.14l-0.82,-0.51l-0.32,0.07l-1.44,1.72l-0.05,0.41l0.25,0.77l-0.26,0.85l0,0.53l0.18,0.37l0.86,0.37l0.3,0.72l-0.89,2l-0.32,1.99l-0.71,1.61l-0.03,0.37l-1.03,1.12l-0.53,0.04l-0.26,-0.17l-0.15,-0.29l-0.23,-1.77l-0.23,-0.49l-0.79,-0.83l-0.39,-0.19l-0.54,0.01l-0.51,0.3l-0.35,0.41l-0.23,1.41l-0.4,0.76l-0.8,0.75l-0.51,0.12l-0.38,-0.11l-0.14,-0.3l0.22,-2.39l-0.26,-1.43l-0.26,-0.42l-0.95,-0.63l-0.3,-0.04l-0.62,0.29l-0.13,0.4l0.04,0.54l-0.31,0.23l-0.28,-0.06l-0.43,-1.06l-0.32,-0.01l-0.35,0.3l-0.47,0.72l-0.48,-0.02l-0.26,0.15l-0.83,0.88l-0.5,0.29l-0.4,0.03l-1.21,-0.43l-0.41,-0.37l-0.61,-1.02l-0.8,-0.19l-1.23,-0.8l-0.59,0.03l-2.66,1.81l-0.56,-0.2l-0.54,-1.23l-0.92,-0.86l-0.86,-0.54l-0.58,-0.85l-0.53,-0.5l-0.27,-0.04l-0.71,0.32l-0.47,0.68l-0.83,2.06l-0.3,0.44l-0.33,0.16l-0.86,-0.35l-0.5,-0.61l-0.22,-0.9l0.03,-1.09l0.74,-0.95l0.18,-0.6l-0.1,-0.35l-0.62,-0.91l-0.25,-0.74l-0.07,-1.79l0.42,-0.92l0.25,-1.16l-0.49,-2.05l-2.55,-4.08l-0.42,-1.17l-0.19,-0.16l-1.21,-0.34l-0.31,0.03l-1.14,0.85l-1.23,-0.06l-1.52,0.48l-0.98,0.84l-0.41,0.74l-1.68,1.39l-2.08,0l-0.5,-0.54l0,0l-0.68,1.93l-2.97,4.11l0.67,7.3l1.91,2.62l0.66,1.34l0.24,2.33l0.03,1.75l-0.15,0.88l0.2,0.42l0,0l0.45,-0.02l0.73,0.4l0.27,0.68l1.1,0.89l0.07,0.62l0.32,0.24l0.88,1.19l0.68,0.02l0.55,1.37l1.01,1.25l0.39,0.89l1.11,1.65l0.46,1.18l0.27,0.01l0.12,0.37l0.97,0.83l0.56,1.37l0.83,0.31l0.53,0.47l0.73,0.99l-0.48,0.38l-0.17,-0.09l-0.29,0.18l0.08,0.32l-0.19,0.29l-0.37,0.1l-0.57,-0.25l-0.47,-1.21l-0.37,1.24l0.04,0.71l0.32,0.64l0.83,-0.24l1.23,0.1l0.85,0.45l-0.28,0.18l0.9,0.04l0.43,0.23l1,0.85l0.22,0.49l0,0l0.34,-0.09l0.26,-0.26l4.87,-1.25l3.38,-0.61l6.75,-0.1v0.22l-0.37,0.52l-1.36,1.66l0.83,1.97l1.88,1.85l5.58,2.73l0.4,0.08l0.76,-0.42l3.02,-2.85l0.76,-1l0.75,-1.45l1.23,-0.79l4.11,-2.23l3.44,-1.03l0,0l1.9,-1.21l-2.2,-2.67l2.03,-1.89l1.2,-0.8l8.59,-2.19l3.67,0.03l0.58,0.25l0.73,0.56l3.33,0.75l1.46,0.15l4.88,-0.44l0.53,-0.27l0.4,-0.46l1.26,-5.86l0,0l-0.42,-0.26l-0.45,-0.58l0.16,-0.33l1.26,-0.3l0.53,-0.41l0.47,-1.02l-0.45,-0.82L749.08,282.29zM678.62,296.98l-3.18,-4.31l-1.22,-0.9l-1.01,-0.03l-0.19,-0.68l0.27,-0.47l0.73,-0.56l-0.27,0.38l1.2,0.51l1.51,1.77l1.73,2.35l0.64,1.58L678.62,296.98z"
                      />
                      <radialGradient
                        id="SVGID_7_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([31])"
                        :class="{ active: selectedRegion === 31 }"
                        class="st1"
                        d="M498.17,276.13L497.65,280.89L497.43,280.85L497.14,283.78L490.43,284L491.56,294.64L492.28,295.91L493.23,296.49L497.5,297.54L497.75,297.77L497.98,298.3L499.55,305.16L499.27,305.9L496.15,311.22L491.72,319.81L490.99,321.6L490.99,321.6L489.73,318.13L487.87,315.47L486.9,314.35L486.32,314.08L484.21,316L481.86,317.29L480.48,317.4L478.65,317.15L477.61,316.36L476.58,314.81L475.39,314.72L474.28,314.91L473.37,315.99L471.22,320.67L470.63,325.58L470.88,325.93L471.42,326.13L471.79,326.85L471.62,329.12L470.74,335.24L469.88,336.58L467.58,342.65L467.78,343.63L468.58,343.73L470.01,342.81L470.83,342.88L471.01,343.33L470.87,344.45L470.44,345.07L466.95,348.36L465.32,349.12L456.41,351.05L455.19,350.85L449.81,348.55L447.72,347.41L447.26,346.37L446.26,344.82L440.78,342.75L439.77,342.58L439.25,342.86L438.9,343.43L438.74,344.13L438.79,345.1L438.37,350.9L436.54,356.44L435.83,357.73L435.31,358.03L434.72,358.04L431.87,357.16L430.87,356.67L422.22,359.59L421.72,359.94L421.64,360.31L421.97,361.08L423.45,362.61L424.42,363.42L425.36,364.87L426.71,370.09L426.54,371.06L426.03,372.52L424.86,374.86L424.82,375.49L424.99,376.3L425.8,378.11L427.92,381.91L427.92,381.91L427.52,382.34L426.99,382.55L424.39,382.95L423,383.32L422.2,383.7L421.03,384.51L421.03,384.51L421.03,384.51L421.03,384.51L420.74,381.13L420.38,379.98L415.99,370.59L411.08,366.9L407.88,367.68L406.8,367.62L399.74,364.95L398.55,363.8L394.28,358.01L395.7,355.29L396.59,354.96L400.99,352.29L403.12,349.82L405.65,345.04L406.94,339.33L407.39,334.97L407.03,331.65L407.39,331.03L408.5,330.55L410.56,330.67L412.56,331.97L413.38,332.76L415.39,333.75L418.29,334.29L422.14,334.52L423.08,334.14L423.72,333.53L427.07,329.39L428.52,325.26L428.69,324.23L432.68,321.42L434.08,312.16L426.11,311.02L420.18,310.39L411.55,309.2L410.52,308.86L409.72,308.44L408.58,307.34L406.44,297.22L405.65,294.39L404.68,294.17L404.23,294.36L403.51,296.46L402.38,299.14L400.11,299.52L396.32,299.58L391.3,300.16L390.73,300.35L389.91,304.84L389.72,305.33L373.53,303.44L373.43,295.83L371.76,293.9L370.88,293.75L368.69,294.92L367.65,296.01L362.27,308.2L361.72,308.39L359.08,308.62L355.68,308.71L356.16,306.48L355.82,304.99L355.26,303.94L353.14,302.27L343.31,296.57L334.83,291.97L329.45,289.66L326.29,288.75L324.25,288.8L323.8,289.17L322.92,289.26L322.35,287.87L320.95,282.72L318.87,278.37L317.3,276.79L313.76,274.89L311.37,273.34L309.22,271.02L307.83,268.96L304.49,262.26L303.44,262.34L289.89,265.55L286.22,266.47L285.66,266.75L285.66,266.75L264.74,238.08L277.59,230.98L270.85,218.83L272.11,203.06L299.77,150.85L284.33,146.67L278.48,136.18L278.48,136.18L320.84,127.93L341.29,124.32L344.77,125L347.78,125.36L357.48,126.41L363.41,126.79L365.81,127.21L379.99,128.3L393.63,128.97L393.83,128.82L394.68,128.78L405.2,123.61L412.2,120.55L416.58,118.36L418.64,117.85L419.72,117.74L421.39,117.81L422.22,118.13L422.98,118.71L423.97,119.85L429.7,132.47L431.72,134.38L435.32,138.12L446.2,147.8L447.7,153.87L454.34,175.26L466.91,169.34L467.26,200.64L467.21,207.85L466.63,207.67L464.21,206.44L463.96,206.44L463.86,213.04L462.95,214.14L462.65,230.78L462.72,232.93L486.86,235.85L490.34,275.55z"
                      />
                      <radialGradient
                        id="SVGID_8_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([29])"
                        :class="{ active: selectedRegion === 29 }"
                        class="st1"
                        d="M421.03,384.51L422.2,383.7L423,383.32L424.39,382.95L426.99,382.55L427.52,382.34L427.92,381.91L427.92,381.91L428.61,382.07L446.16,382.6L447.65,382.42L448.96,381.87L450.39,380.8L450.58,380.53L450.62,380.2L454.93,381.08L458.23,384.89L461,389.54L461.09,391.03L461.31,391.24L462.03,391.49L465.11,392.27L466.64,392.23L468.85,390.85L472.12,389.18L479.67,387.31L480.3,387.47L481.47,388.22L483.12,389.66L484.76,390.81L485.45,391.14L485.75,391.13L489.39,389.57L490.21,388.61L491.31,386.83L492.14,385.88L492.95,385.6L494.14,385.54L502.71,387.07L503.34,387.74L503.83,389.06L503.72,390.32L503.26,392.02L503.32,392.6L503.65,393.08L504.58,393.61L506.47,393.76L510.35,393.52L511.17,393.31L511.59,392.83L511.7,392.48L511.63,390.7L512.06,390.22L512.94,390.17L517.4,391.44L519.96,392.53L523.8,393.72L525.45,394.04L526.45,393.81L526.45,393.81L526.83,395.39L528.22,397.8L528.95,398.55L529.91,399.08L531.67,399.45L532.29,399.86L533.14,400.15L533.94,400.17L534.97,399.95L536.05,400.14L537.07,400.61L537.72,402.28L538.29,402.51L539.88,402.59L540.16,402.88L540.15,403.45L539.8,403.96L539.59,406.46L540.03,407.72L540.16,409.77L540.55,410.33L540.55,410.33L539.75,411.15L538.77,411.73L534.78,411.96L533.92,412.22L533.41,412.47L532.74,413.04L532.29,413.88L532.23,414.28L532.77,417.42L533.79,419.52L534.17,419.98L534.32,420.5L534.45,424.7L533.11,429L532.57,428.82L531.16,427.39L530.16,427.07L528.73,427L527.59,427.33L527.14,427.67L526.55,428.31L525.74,429.61L524.55,431.83L515.66,440.71L514.94,444.06L514.78,445.58L514.41,446.98L513.96,447.85L511.54,450.28L509.71,451.56L506.17,453.41L494.59,465.51L494.16,466.76L493.12,471.03L493.39,471.93L493.39,471.93L491,469.14L489.95,468.47L488.47,467.86L485.28,467.51L482.65,468.33L482.08,468.39L480.82,468.06L479.59,466.99L476.8,465.35L474.97,463.28L473.68,460.95L473.21,460.65L471.31,460.54L467.81,459.51L467.18,459.11L466.68,458.14L465.51,457.74L464.64,457.61L463.88,456.81L463.41,456.64L462.04,456.71L461.21,456.44L460.31,455.84L458.4,453.88L457.5,453.64L456.43,453.65L455.46,453.92L454.73,455.32L454.17,455.25L454.03,455.35L453.87,455.99L453.5,456.16L452.97,456.16L448.29,455.2L438.36,451.28L436.41,450.16L430,446.03L428.15,444.54L425.45,442.02L417.84,434.42L417.26,434.03L414.53,432.78L411.03,431.45L408.09,430.08L406.36,428.82L405.75,428.16L396.77,422.61L394.05,420.71L388.51,415.58L387.32,414.27L387.32,414.27L392.93,408.04L411.05,401.4L411.33,400.79L411.1,400.28L410.28,399.11L409.45,398.23L408.74,397.03L408.59,396.17L408.94,395.14L413.34,390.43L413.91,390.32L417.26,388.1z"
                      />
                      <radialGradient
                        id="SVGID_9_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([30])"
                        :class="{ active: selectedRegion === 30 }"
                        class="st1"
                        d="M157.2,24.88l0.35,7.72l-2.01,5.84l-3.22,5.44l-2.82,6.04l-1.01,4.23h-2.21l-1.81,0.2l-1.41,1.41l-0.6,2.62l0.81,4.63l1.21,2.62l0.81,2.82l-2.42,0.81l-3.02,-1.61l-2.42,1.41l-1.81,4.03l-2.42,4.23l-2.21,2.42l-3.02,-1.81l-0.4,-4.03l-0.2,-6.24l-1.21,-1.61V62.6h1.61l1.21,2.82l1.81,1.01l2.82,-1.01l1.41,-3.02v-4.03l1.01,-3.22L133,53.34l-3.22,-2.62l-0.6,-2.42l1.81,-2.01l1.81,-0.4l2.01,1.01l0.2,-8.25l2.82,-0.4l-0.2,-3.22l-2.42,-0.6l-3.82,-0.6l-1.41,1.01l-1.61,2.01l-2.21,1.01l1.41,-2.21l2.82,-5.23l1.81,-2.62l-1.01,-3.02l-2.01,-2.82l0.6,-3.82l1.01,-3.42l3.4,-6.43l0,0L157.2,24.88zM118.88,1.48l-0.18,3.55l-1.61,3.22l-0.2,4.83l-3.82,3.42l-2.01,3.22l-0.2,5.84l-2.62,2.62l-1.21,5.64l-3.02,4.83L102,44.08l-0.4,4.63l0.2,6.04l1.21,2.82l2.01,3.62l-0.4,2.62l-3.02,8.45l0.4,5.23l2.21,5.23l2.21,2.62l3.02,1.41l4.03,1.61l3.02,0.2l2.62,2.01l2.01,0.6l1.01,-2.01l1.61,-0.4l2.42,0.2l1.81,-0.81l5.03,-1.61l2.62,-1.21l1.61,1.01l0.81,3.62l-1.81,2.21L133.4,94l1.01,3.62l2.21,1.01l1.81,1.81l5.23,0.81l2.62,2.21l3.02,0.4l6.04,0.6l4.43,0.2l3.62,-2.21l2.42,1.41l1.21,1.01l3.82,-0.81l2.01,-0.6l3.62,1.21l5.03,-1.01l4.83,-1.61l7.05,-2.82l0.6,-2.62h3.42l1.21,-1.81L197.61,93l1.61,-3.42l6.24,-5.03l4.63,-4.63l2.82,-5.03l0.81,-3.82l-1.01,-1.41l-1.61,-1.41l-1.01,-2.01l3.88,-0.35l0,0l21.68,15.65l2.21,7.05l6.07,6.13l6.39,7.71l0.29,0.64l0.64,0.59l2.53,3.01l5.7,7.01l16.83,20.9l1.63,1.56l0.55,0.05l0,0l5.85,10.5l15.43,4.18l-27.66,52.2l-1.26,15.77l6.74,12.15l-12.85,7.1l20.92,28.67l0,0l13.79,19.18l-10.94,5.06l0,0l-2.55,1.21l-0.65,-0.19l-0.27,-0.22l-4.56,-7.41l-1.5,-2.77l-8,-8.81l-3.08,-1.91l-3.52,-1.86l-8.95,-2.06l-3.04,-0.02l-0.62,0.2l-1.39,0.77l-0.78,0.89l-1.17,2.3l-0.51,1.87l-0.72,0.77h-1.49l-2.25,-1.44l-0.25,-1.16l-0.37,-0.87l-2.02,-2.27l-0.71,-0.61l-0.74,-0.29l-2.16,-0.36l-1.41,-0.58l-5.96,-4.54l-8.23,-7.31l-1.57,-1.5l-3.35,-3.9l-5.17,-4.83l-0.69,-0.31l-0.67,-0.65l-0.37,-0.46l-3.08,-5.39l-0.41,-2.46l-0.04,-2.63l-0.17,-0.58l-0.39,-0.48l-5.28,-1.12l-4.26,1.39l-1.9,0.84l-2.67,5.23l0,0l-0.22,-0.53l-0.5,-0.6l-0.55,-0.39l-2.42,-0.83l-0.81,-0.51l-1.78,-2.19l-0.17,0.04l-0.33,-0.35l-0.88,0.2l-1.26,-1.24l-0.19,-0.81l0.19,-0.34l0.56,-0.45l2.82,-0.2l0.35,-0.45l-0.2,-0.8l-0.51,-0.73l-0.41,-0.97l-0.22,-0.94l-0.16,-2.27l-1.26,-1.64l-0.03,-0.67l0.18,-0.48l1.09,-0.58l0.42,0.19l0.85,0.1l0.46,-0.11l0.45,-0.43l0.25,-0.39l0.02,-0.64l-0.49,-1.19l-0.48,-0.56l-0.99,-0.6l-1.75,-0.24l-0.58,-0.24l-0.82,-0.71l-0.83,-1.12l-0.68,-1.36l-0.63,-0.56l-1.97,-0.64l-1.04,-0.84l-0.31,0.55l-0.46,1.43l-0.36,0.35l-0.5,0.01l-1.8,-0.55l-0.68,-0.35l-0.46,0.02l-0.54,-0.21l-1.97,-0.04l-1.57,0.37l-1.51,0l-1.34,0.16l-7.41,0.1l-0.57,-0.45l-0.73,-1.4l-0.65,-0.3l-0.88,-1.06l-4.04,-4.03l-0.04,-0.4l0.46,-1.24l-0.11,-1.23l-3.41,-4.45l-0.47,-0.46l-1.11,-0.66l-0.4,-0.06l-1.09,0.3l-0.96,0.77l-0.57,0.24l-2.6,-0.17l-0.7,-0.22l-1.58,-0.86l-2.27,-0.66l-0.67,-0.32l-1.73,-1.5l-4.19,-4.6l-4.81,-5.35l-3.08,-3.9l-0.48,-0.43l-0.03,0.85l-0.31,1.18l0.1,0.55l0.89,0.89l0.04,0.29l-0.17,0.52l-0.34,0.22l-0.42,-0.01l-0.55,-0.31l-0.63,0l-0.51,0.63l0,0.17l0.69,0.57l0.26,0.42l-0.42,2.18l-0.31,0.49l-0.49,0.3l-1.15,-0.37l-2.65,0.5l-1.07,0.06l-1.32,-0.64l-1.21,-0.24l-1.19,-0.57l-1.49,-0.41l-2.9,-0.6l-0.9,0.03l-1.42,0.57l-1.04,0.6l-2.33,1.94l-0.62,0.06l-0.41,0.35l-0.18,0.69l0.32,0.76l1.86,1.35l2.37,1.33l0.99,0.38l1.35,0.25l0.45,0.54l2.67,6.2l1.3,2.05l0.57,0.68l0.19,0.94l-0.04,1.21l0.44,0.4l0.53,-0.13l3.15,1.98l0.96,0.79l0.13,0.71l-0.51,1.04l-0.37,0.26l-0.43,0.02l-2.11,-0.5l-1.87,0.38l-0.19,-0.67l0.12,-2.02l-0.11,-1.05l-0.81,-2.86l-0.71,-1.34l-0.89,-0.99l-1.25,-0.84l-4.85,-1.25l-0.8,0.05l-2.18,1.13L98.38,202l-0.19,-0.1L98,201.18l-0.92,-0.65l-0.29,-0.37l-0.27,-1.2l-0.85,-0.75l-0.96,-0.18l-1.43,0.31l-0.99,0.68l-0.53,-0.01l-0.27,0.29l-0.4,1.83l-0.29,0.75l-0.32,-0.13l-0.74,-0.86l-0.44,-0.11L88.63,201l-0.22,0.39l-0.28,1.55l0.34,0.78l0.89,0.82l0.44,0.72l0.33,1.08l-0.02,0.54l-0.37,1.05l0.03,1.41l-0.24,1.11l0.12,1.55l-0.2,1.61l-0.18,0.6l-0.34,0.39l-0.47,0.16l-0.85,-0.03l-1.66,-0.69l-0.44,0.1l-0.28,0.52l-0.34,1.2l0.7,1.2l0.44,1.1l-0.19,0.42l-0.87,0.12l-3.06,-0.52l-2.59,0.89L77.55,220l-0.74,0.18l-0.6,-0.02l-1.62,-0.99l-1.87,-0.37l-2.29,-0.18l-5.17,0.28l-1.96,0.73l-2.52,1.24l-2.19,1.6l-1.26,1.09l-1.12,1.61l-0.41,0.87l-0.68,1.59l-1.07,3.33l-0.61,0.85l-1.13,1.1l-0.71,0.43l-1.37,0.51l-2.16,0.64l-0.73,0.44l-0.86,0.79l-0.92,1.92l-0.31,2.04l-0.45,1.83l0.05,2.75l0.3,2.68l-0.14,2.73l0.56,2.37l0.4,0.99l0.38,0.5l-0.02,0.24l0.36,0.16l0.53,1.03l0.24,1.15l0.09,0.8l-0.2,1.22l0,2.34l0.42,3.14l0.3,0.99l0.38,0.72l1.85,2.64l0.91,0.02l1.95,-0.6l0.43,0.4l0.04,0.52l-0.32,0.71l-0.4,0.4l-0.53,0.33l-1.98,0.69l-0.84,0.79l-0.46,0.88l-0.04,1.5l-0.32,0.67l-0.49,0.54l-0.55,0.29l-1.32,0l-1.8,-0.44l-3.96,-0.34l-4.15,-0.59l-6.75,-0.42l-3.77,-0.08l-5.88,-0.68l-3.49,-0.26l-1.88,0.01l-5.18,-0.47l-9.42,-0.39L0.02,38.88l1.52,-0.39l1.43,-0.63l30.14,-9.85l0.02,-0.13l1.67,-0.29l0.34,-0.35l1.01,-0.34l13.14,-4.2L92.95,9.2l6.65,-2.22l2.22,-0.46L118.88,1.48z"
                      />
                      <radialGradient
                        id="SVGID_10_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([33])"
                        :class="{ active: selectedRegion === 33 }"
                        class="st1"
                        d="M532.69,391.98L532.58,392.28L530.98,391.97L530.01,392.18L526.68,393.33L526.45,393.62L526.45,393.81L526.45,393.81L525.45,394.04L523.8,393.72L519.96,392.53L517.4,391.44L512.94,390.17L512.06,390.22L511.63,390.7L511.7,392.48L511.59,392.83L511.17,393.31L510.35,393.52L506.47,393.76L504.58,393.61L503.65,393.08L503.32,392.6L503.26,392.02L503.72,390.32L503.83,389.06L503.34,387.74L502.71,387.07L494.14,385.54L492.95,385.6L492.14,385.88L491.31,386.83L490.21,388.61L489.39,389.57L485.75,391.13L485.45,391.14L484.76,390.81L483.12,389.66L481.47,388.22L480.3,387.47L479.67,387.31L472.12,389.18L468.85,390.85L466.64,392.23L465.11,392.27L462.03,391.49L461.31,391.24L461.09,391.03L461,389.54L458.23,384.89L454.93,381.08L450.62,380.2L450.58,380.53L450.39,380.8L448.96,381.87L447.65,382.42L446.16,382.6L428.61,382.07L427.92,381.91L427.92,381.91L425.8,378.11L424.99,376.3L424.82,375.49L424.86,374.86L426.03,372.52L426.54,371.06L426.71,370.09L425.36,364.87L424.42,363.42L423.45,362.61L421.97,361.08L421.64,360.31L421.72,359.94L422.22,359.59L430.87,356.67L431.87,357.16L434.72,358.04L435.31,358.03L435.83,357.73L436.54,356.44L438.37,350.9L438.79,345.1L438.74,344.13L438.9,343.43L439.25,342.86L439.77,342.58L440.78,342.75L446.26,344.82L447.26,346.37L447.72,347.41L449.81,348.55L455.19,350.85L456.41,351.05L465.32,349.12L466.95,348.36L470.44,345.07L470.87,344.45L471.01,343.33L470.83,342.88L470.01,342.81L468.58,343.73L467.78,343.63L467.58,342.65L469.88,336.58L470.74,335.24L471.62,329.12L471.79,326.85L471.42,326.13L470.88,325.93L470.63,325.58L471.22,320.67L473.37,315.99L474.28,314.91L475.39,314.72L476.58,314.81L477.61,316.36L478.65,317.15L480.48,317.4L481.86,317.29L484.21,316L486.32,314.08L486.9,314.35L487.87,315.47L489.73,318.13L490.99,321.6L490.99,321.6L498.78,322.52L503.39,322.62L504.35,324.8L504.36,325.9L503.53,327.73L503.39,328.5L503.49,332.43L504.33,336.53L506.19,338.19L507.63,341L507.56,341.81L507.11,343.15L506.87,343.31L505.63,343.6L505.53,343.95L505.88,347.66L511.71,351.59L513.83,352.39L518.64,352.79L530.51,355.32L530.72,355.56L531.79,361.52L531.87,362.54L530.57,362.69L529.03,363.07L526.87,364.1L526.18,364.64L525.42,365.55L522.2,370.79L522.1,371.16L522.12,375.32L522.33,376.27L522.98,377.23L524.01,378.28L528.54,382.1L528.54,382.1L530.77,386.77L531.6,389.07L532.54,391.02L532.75,391.83z"
                      />
                      <radialGradient
                        id="SVGID_11_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([34])"
                        :class="{ active: selectedRegion === 34 }"
                        class="st1"
                        d="M595.9,338.94L594.29,339.91L593,340.24L590.61,339.57L589.63,340.01L584.19,341.75L584.19,341.75L585.2,335.34L584.89,334.66L577.76,336.3L575.48,337.09L571.46,337.91L566.89,338.08L560.34,337.77L560.02,337.72L559.36,336.75L559.02,335.85L558.87,334.89L559.07,333.37L564.02,322.33L564.79,320.33L564.94,319.56L564.78,319.36L564.45,319.46L562.34,320.48L562.18,320.21L562.66,315.32L564.76,314.78L566.62,314.88L566.96,314.27L567.13,311.43L567.13,311.43L570.78,314.54L572.67,314.04L574.58,315.61L574.04,316.75L578.91,318.18L579.72,317.06L582.12,317.24L586.43,315.51L585.59,313.42L583.18,312.13L582.05,308.84L578.77,304.31L579.64,296.86L578.64,294.33L579.5,293.43L578.62,292.04L575,291.81L574.99,290.51L579.91,290.82L580.23,291.42L582.59,289.95L582.57,290.19L582.88,290.28L583.08,291.48L583.75,291.73L584.55,291.36L585.49,291.57L585.86,291.95L585.72,292.28L584.28,292.83L584.09,293.18L584.06,293.74L584.6,294.8L585,294.47L585,294.47L589.86,299.99L593.33,303.46L598.25,307.9L602.96,311.81L603.58,311.89L606.61,316.12L606.11,320.82L605.25,326.14L604.24,331.1L604.26,332.16L604.4,332.78L604.9,333.83L604.65,338.56L604.65,338.56L603.54,338.21L600.97,338.19L597.61,338.54z"
                      />
                      <radialGradient
                        id="SVGID_12_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([35])"
                        :class="{ active: selectedRegion === 35 }"
                        class="st1"
                        d="M573.04,460.61L572.01,464.14L571.87,465.37L569.57,467.79L567.93,470.89L568,472.46L567.53,473.57L567.62,474.36L567.27,475.25L564.77,476.42L560.72,477.12L559.91,478.56L556.75,485.31L555.6,486.97L554.23,487.95L551.94,490.92L550.89,493.35L549.62,495.78L548.03,497.31L546.84,501.19L546.79,503.75L547.05,507.76L546.49,514.42L545.78,516.85L545.1,517.29L544.51,516.18L543.01,514.98L542.27,514.76L540.89,514.91L540.47,514.85L539.61,514.09L538.61,513.5L538,513.59L536.63,514.14L535.96,514.68L535.57,515.18L534.87,515.27L534.45,514.62L534.03,513.25L533.29,512.53L532.47,512.13L531.8,512.27L531.23,512.65L529.36,514.37L528.01,514.83L526.86,515.51L525.6,515.62L523.76,516.09L522.8,517.12L521.3,517.75L520.76,517.55L519.9,516.78L519.73,515.25L519.45,514.76L518.68,514.39L518.31,513.52L518.04,513.25L517.07,512.87L516.62,512.53L515.92,512.68L515.46,512.56L513.94,511.71L513.48,511L513.84,509.47L513.52,508.63L511.79,507.77L510.43,506.36L510,506.1L508.07,505.38L506.19,505.51L502.61,507.1L501.03,506.91L500.21,506.98L497.98,507.74L496.03,507.25L495.08,507.26L493.98,507.63L492.38,507.26L490.93,507.49L489.76,507.37L487.97,507.44L486.66,507.98L486.26,505.97L486.43,505.31L486.86,504.69L487.72,504.06L488.85,503.48L491.89,502.57L492.19,501.84L492.2,501.09L491.77,499.99L487.21,494.45L486.95,492.96L487.51,487.34L487.22,485.81L487.22,485.21L487.67,482.1L488.41,480.31L489.14,479.19L489.91,478.43L490.45,477.16L491.01,476.43L493.29,475.1L493.72,474.7L493.96,473.87L493.93,472.98L493.39,471.93L493.39,471.93L493.12,471.03L494.16,466.76L494.59,465.51L506.17,453.41L509.71,451.56L511.54,450.28L513.96,447.85L514.41,446.98L514.78,445.58L514.94,444.06L515.66,440.71L524.55,431.83L525.74,429.61L526.55,428.31L527.14,427.67L527.59,427.33L528.73,427L530.16,427.07L531.16,427.39L532.57,428.82L533.11,429L534.45,424.7L534.32,420.5L534.17,419.98L533.79,419.52L532.77,417.42L532.23,414.28L532.29,413.88L532.74,413.04L533.41,412.47L533.92,412.22L534.78,411.96L538.77,411.73L539.75,411.15L540.55,410.33L540.55,410.33L540.94,410.86L541.62,411.15L542.53,410.83L543.15,411.07L544.19,410.35L546.24,410.16L547.59,410.98L549.06,411.12L550.11,409.77L552.16,409.7L553.2,409.15L553.65,409.16L554.76,410.32L555.78,410.57L557.62,409.58L558.87,409.72L560.11,410.54L560.98,412.38L561.29,413.41L563.98,415.51L564.07,416.31L563.93,417.55L563.58,417.77L563.88,419.93L562.62,420.58L562.03,421.48L561,421.8L558.5,422.2L558.15,422.76L560.68,426.44L560.32,427.11L558.73,427.3L557.46,428.52L557.88,430L558.75,431.94L558.74,432.39L558.27,432.95L557.94,438.26L560.36,441.47L561.36,442.28L560.99,443.4L560.06,444.85L559.81,445.86L560.26,445.87L561.74,445.22L562.2,445.23L563.87,446.17L565.28,448.57L565.49,449.36L565.57,450.72L565.79,450.95L567.13,451.43L568.58,452.14L569.58,452.83L571.55,455.36L571.57,455.74L572.29,457.06L573.38,458.55L573.37,459.34z"
                      />
                      <radialGradient
                        id="SVGID_13_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>

                      <path
                        @click="onRegionSelect([36])"
                        :class="{ active: selectedRegion === 36 }"
                        class="st1"
                        d="M705.51,217.27l-0.15,-0.38l-0.65,-0.51l-0.79,-0.38l-3.33,-3l-0.94,-0.54l-1.75,-0.21l-1.22,-0.7l-0.46,-0.02l-0.86,0.21l-1.14,0.5l-1.25,1.16l-0.68,0.03l-0.94,-0.34l-0.42,0.04l-1.77,2.24l-1.02,0.69l-0.96,0.43l-1.18,0.89l-0.7,0.02l-1.06,-1.01l-0.52,0.16l-0.58,0.56l-0.67,0.73l-0.84,1.38l-0.82,0.66l-0.55,0.9l-0.98,0.78l-0.75,1.09l-0.15,1.26l-0.91,1.8l-1.1,2.99l0.05,0.2l-0.22,0.48l-0.74,0.26l-0.42,-0.02l-1.23,-1.13l-0.75,-0.21l-0.15,-0.63l0.11,-1.61l-0.55,-0.91l-2.54,-1.39l-2.69,-2.37l-0.37,-0.16l-0.69,0.14l-0.37,0.46l-0.3,2.12l-0.22,0.37l-0.97,0.87l-0.3,0.69l-1.58,0.96l-0.31,0.5l0.13,1.17l0.34,1.39l-0.08,1.08l-1.04,0.74l-0.96,0.31l-0.49,0.55l-0.54,-0.02l-1.16,0.55l-0.89,1.3l-1.07,0.9l-0.44,0.76l-0.74,2.01l-0.59,1.01l-3.19,1.6l-1.34,0.96l-0.73,2.14l-0.32,0.3l-0.33,0.12l-0.36,-0.12l-0.16,-0.29l0.05,-0.56l-0.38,-0.67l-0.39,-0.07l-0.68,0.2l-0.26,0.31l-1.65,3.99l-2.93,1.2l-1.2,-1.04l-0.74,-0.33l-0.5,0l-1.67,1.05l-2.04,0.33l-0.25,-0.13l-0.84,0.13l-0.31,0.2l-0.2,0.44l-0.53,0.53l-0.68,0.33l-2.74,0.65l-0.52,0.23l-1.22,1.14l-0.29,0.51l-0.95,0.71l-1.3,1.39l-0.4,0.54l-0.5,1.56l-0.23,0.28l-0.74,0.38l-1.22,0.35l-0.38,-0.06l-0.33,0.12l-1.68,1.43l-0.67,1.1l0.02,0.52l0.33,0.54l1.17,0.76l-0.34,1.01l-0.41,0.21l-2.21,-0.35l-0.53,0.23l-0.83,0.04l-1.31,0.35l-0.47,-0.02l-1,-0.58l-0.56,-0.14l-1.1,0.13l-0.36,-0.12l-1.5,0.32l-1.15,0.69l-0.64,1.9l-0.44,0.5l-2.23,1.26l-1.14,2.84l-0.66,0.46l-0.51,-0.06l-0.59,-0.58l-0.29,-0.12l-0.51,0.16l-1.98,3.07l-0.19,2.71l-0.23,0.37l-1.39,1.17l-0.3,1.8l-0.21,0.14l-0.85,-0.15l-0.68,0.46l-0.65,0.86l-1.41,1.37l-1.53,2.02l-0.74,1.15l-0.48,1.1l-1.66,2.09l-0.72,1.67l-0.15,1.51l-0.17,0.35l-1.33,1.21l-1.83,0.72l-1.04,0.86l0,0l4.86,5.52l3.47,3.47l4.92,4.44l4.71,3.91l0.62,0.08l3.03,4.23l-0.5,4.7l-0.86,5.32l-1.01,4.96l0.01,1.06l0.14,0.62l0.5,1.06l-0.25,4.73l0,0l2.55,0.22l0.64,-0.05l1.05,0.37l1.09,-0.09l0.77,-0.25l1.3,0.31l1.96,0.04l1.12,0.62l0.48,-0.4l-0.84,-2.12l-0.41,-0.42l-1.38,-0.27l-0.41,-0.42l0.24,-0.85l-0.35,-0.58l0.18,-0.62l1.75,0.24l0.83,-0.06l1.13,-1.07l0.01,-0.91l0.33,-0.55l-0.02,-1.21l-1.04,-0.83l-0.42,-0.5l0.01,-0.83l-0.29,-0.81l-0.4,-0.35l0.24,-0.85l-0.47,-0.19l-0.61,-2.07l-0.42,-0.5l0.01,-0.83l0.35,-0.41l0.04,-0.76l-0.66,-0.57l-1.34,-1.85l-0.07,-0.33l0.27,-0.64l1.56,-1.05l1.82,-0.24l0.87,0.17l0.3,-0.08l0.26,-0.27l-0.03,-0.18l0.4,-0.75l0.48,-0.23l0.26,-1.27l-0.56,-1.23l-0.34,-1.13l0.21,-3.51l0.06,-0.32l0.33,-0.39l0.2,-0.95l1.84,-2.59l1.64,-0.2l0.66,0.33l2.53,0.7l1.21,0.15l0.75,0.74l0.85,1.71l0.25,1.19l0.55,0.78l1.26,0.9l0.73,0.88l0.69,0.11l0.4,0.21l0.5,1.3l0.3,0.41l0.66,0.15l1.62,-0.11l0.93,-0.59l1.4,-3.02l0.45,-0.4l0.71,-0.21l1.43,0.41l0.3,-0.03l0.94,-1.01l1.11,-0.66l0.43,-0.01l1.59,0.98l0.21,0.01l1.18,-1.12l0.76,-0.49l2.03,-0.29l0.83,-0.36l1.06,-0.9l1.43,-0.56l2.38,-2.32l0.31,-0.44l0.28,-0.87l0.49,-0.59l0.59,-0.11l1.03,0.41l1.14,0.18l1.46,-0.94l0.88,-0.39l0.72,-1.02l1.64,-0.99l1.2,-0.03l0.68,-0.23l0.37,-0.36l0.51,-1.01l0.01,-0.36l-0.29,-0.93l0.15,-0.72l0.68,-0.82l0.03,-0.76l0.3,-0.53l-0.28,-1.28l0.11,-0.46l0.38,-0.28l0.4,-0.94l0.55,-0.6l1.3,-0.52l1.03,0.25l0,0l-0.2,-0.42l0.15,-0.88l-0.03,-1.75l-0.24,-2.33l-0.66,-1.34l-1.91,-2.62l-0.67,-7.3l2.97,-4.11l0.68,-1.93l0,0l-0.49,-1.01l-0.48,-0.56l-0.85,-0.56l-1.21,-1.45l-1.17,-0.12l-0.5,-0.52l-0.63,-1.47l-0.4,-0.27l-1.31,-0.56l-1.07,-0.18l-0.97,0.06l-0.52,0.28l-0.82,0.1l-0.94,-0.24l-1.25,0.09l-0.63,-0.37l-0.16,-0.37l-0.17,-1.24l0.08,-1.97l0.28,-0.74l0.41,-0.58l1.27,-0.54l0.69,-0.12l1.28,0.11l1.66,-1.54l1.3,0.05l0.85,-0.4l1.51,-1.46l0.58,-0.9l0.3,-0.23l2.07,-1.13l0.54,-0.16l1.66,-1.13l0.67,-1.34l0.09,-2.21l0.24,-0.49l0.62,-0.59l1.24,-0.56l2.17,-1.52l0.33,-1.21l1.12,-0.8l0.37,-0.42l0.74,-1.53l1.05,-1.08l1.19,-0.57l0.65,-0.05l0.88,0.32l0.41,-0.01l0.17,-0.19l0.17,-0.82l0.22,-0.2l0.68,0.46l1.04,0.36l0.88,0.01l0.43,-0.15l0.89,-0.9l0.3,-0.51l0.16,-1.82l-0.91,-1.58l0.34,-0.9l0.65,-0.66l0.12,-0.73l0.17,-0.29l0.6,-0.29l0.8,0l1.87,1.04l0.81,0.2l0.77,0l1.05,-0.52l1.29,-1.1l0.68,-0.3l1.76,-1.81l0.81,-0.31l2.68,-2.56l1.08,-0.41l0.82,-0.03l1.27,0.31l0.4,-0.62l0.7,-0.54l0.45,-0.18l0.2,-0.28l0.1,-1.57L705.51,217.27zM619.29,268.7l-0.36,0.46l0.09,0.66l-0.39,-0.05l-0.16,0.11l-0.29,0.68l-0.05,0.48l0.14,0.34l-0.34,0.25l-0.48,0.75l0.57,0.75l0.17,0.55v0.89l-0.15,0.55l-0.95,1.14l-0.33,0.23l-0.64,0.09l-0.36,-0.25l-0.43,-0.93l0.16,-0.41l-0.72,-0.23l-1.08,-0.09l-1.08,0.87l-0.02,0.48l-0.57,0.07l-0.69,-0.14l-0.17,-0.25l-0.36,0.23l-0.16,-0.05l-0.33,-0.84l-0.48,-0.25l-0.33,0.18l-0.29,-0.21l-0.93,-0.23l-0.09,-0.34l0.12,-1.46l0.14,-0.87l0.45,-1.25l0.1,-0.84l1.2,-1.32h0.14l0.1,0.18l1.03,0.21l0.83,-0.37l0.26,-0.34l0.21,-0.02l1.6,0.84l0.57,-0.11l0.55,0.27l0.36,-0.66l0.71,0.07l0.7,-0.75l0.6,-0.11l0.38,-0.62l0.45,-0.11l0.04,0.71l0.51,0.46L619.29,268.7z"
                      />
                      <radialGradient
                        id="SVGID_15_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>
                      <path
                        @click="onRegionSelect([37])"
                        :class="{ active: selectedRegion === 37 }"
                        class="st1"
                        d="M 621 266 L 618.76 267.06 L 618.67 266.92 L 618.43 266.92 L 618.13 267.17 L 618 267.54 L 617.25 267.77 L 616.54 268.52 L 615.84 268.45 L 615.48 269.11 L 614.93 268.84 L 614.36 268.95 L 612.76 268.11 L 612.56 268.13 L 612.3 268.47 L 611.48 268.84 L 610.45 268.63 L 610.34 268.45 L 610.2 268.45 L 609 269.77 L 608.9 270.62 L 608.45 271.87 L 608.31 272.74 L 608.19 274.2 L 608.28 274.54 L 608 277 L 604 280 L 602 290 L 605 296 L 614 303 L 622 306 L 627 306 L 630 306 L 632 305 L 634 304 L 636 303 L 638 301 L 639 300 L 641 296 L 643 290 L 641 284 L 642 280 L 641 277 L 638 276 L 637 273 L 635 271 L 630 268 L 627 267 L 626 267 L 625 268 L 624 267 L 623 267 L 623 267 L 622 267 L 621 267 L 621 267 L 621 267 L 621 267 L 621 267 L 620 267 z"
                      />
                      <radialGradient
                        id="SVGID_14_"
                        cx="396.2129"
                        cy="323.7752"
                        r="357.3538"
                        gradientTransform="matrix(1 0 0 -1 0 612)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style="stop-color:#F1F0F0" />
                        <stop offset="1" style="stop-color:#DEDDDD" />
                      </radialGradient>

                      <path
                        @click="onRegionSelect([39])"
                        :class="{ active: selectedRegion === 39 }"
                        class="st1"
                        d="M282.31,313.47L281.05,310.61L280.53,309.86L279.84,309.25L279.54,308.44L279.38,305.67L278.92,304.93L278.66,303.9L277.44,301.86L277.35,300.64L277.51,299.46L277.44,297.48L277.29,297L277.04,294.15L277.27,292.53L277.05,292.13L276.54,291.92L276.36,291.2L276.38,290.56L276.09,289.75L275.35,288.81L273.88,288.03L273.31,287.92L272.86,287.66L272.56,287.1L272.75,286.16L272.38,285.11L271.91,284.24L270.69,283.51L268.81,281.53L267.68,281.19L266.19,280.18L264.16,277.77L263.68,277.47L262.41,277.34L261.75,277.11L261.26,276.77L260.85,276.39L260.57,275.44L260.19,274.72L259.34,274.08L258.87,274.07L257.57,274.64L255.8,274.5L255.06,274.28L253.45,273.38L251.69,273.09L251.17,273.13L250.7,273.44L249.88,274.91L249.94,277.56L249.49,278.36L249.21,279.93L248.78,280.84L248.43,281.23L247.94,281.56L246.89,281.72L246.74,281.86L245.07,282.05L244.74,281.95L243.42,282L243.22,281.87L242.94,281.97L242.24,281.81L239.14,280.33L237.01,278.1L236.67,277.95L234.66,278.13L233.34,276.57L228.43,276.35L228.01,276.56L226.97,276.49L224.79,276.81L222.21,276.69L220.53,277L216.6,277.01L211.84,277.31L210.96,277.26L208.36,277.69L207.41,277.63L206.69,277.39L203.45,275.45L200.54,272.85L194.43,268.68L191.06,266.75L189.9,265.71L189.33,264.47L189.31,263.78L189.47,262.99L189.51,260L189.79,258.14L190.17,257.33L192.31,255.33L192.56,254.72L192.56,253.55L192.29,252.66L191.16,250.64L190.01,249.11L188.16,246.22L187.78,244.72L188.3,243.48L188.86,241.23L189.1,241.09L189.41,241.11L190.31,241.6L191.31,241.58L193.29,242.3L194.4,242.83L195.68,243.88L196.87,243.85L197.65,244.48L198.47,244.75L198.73,244.35L199.46,244.36L199.72,244.2L199.75,243.76L199.23,243.06L198.1,242.17L196.94,240.85L195.69,240.28L194.04,239.91L192.65,239.04L191.89,238.19L191.58,237.47L191.58,237.47L194.25,232.24L196.15,231.39L200.41,230L205.69,231.12L206.08,231.6L206.24,232.18L206.28,234.82L206.69,237.27L209.77,242.66L210.15,243.13L210.81,243.78L211.51,244.09L216.68,248.92L220.03,252.82L221.6,254.33L229.83,261.64L235.79,266.18L237.2,266.76L239.36,267.12L240.1,267.41L240.81,268.02L242.82,270.29L243.19,271.16L243.45,272.32L245.7,273.76L247.19,273.76L247.91,273L248.42,271.12L249.59,268.82L250.37,267.94L251.76,267.17L252.38,266.97L255.42,266.98L264.37,269.04L267.89,270.9L270.97,272.81L278.97,281.62L280.47,284.39L285.03,291.8L285.3,292.02L285.95,292.21L288.5,290.99L288.5,290.99L291.74,294.32L297.65,301L298.33,302.15L298.3,303.69L297.51,307.49L292.92,312.62L286.64,320.23L286.64,320.23z"
                      />
                    </svg>
                  </div>
                </blockquote>
              </router-link>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-col>
    <el-col :sm="24" :md="10" :lg="9" class="mb-lg-10">
      <div class="card card-lift shadow border-0 card-img_card_news">
        <h5 class="card_new_title">{{ $t("homepage.last_news") }}</h5>
        <div class="card_news_items">
          <div v-for="(item, lnIndex) in lastNews" :key="'lastNews_' + lnIndex">
            <div class="time_info">
              <span>{{ parseDate(item.createdDate) }}</span>
              <hr />
              <span v-if="$i18n.locale === 'uz-UZ' || $i18n.locale === 'uz-QR'">{{
                resolveUzQrValue(item.category, ["nameQrq", "nameUzQr"], "nameUzLat")
              }}</span>
              <span v-if="$i18n.locale === 'uz-CYR'">{{
                item.category.nameUz
              }}</span>
              <span v-if="$i18n.locale === 'ru-RU'">{{
                item.category.nameRu
              }}</span>
              <span v-if="$i18n.locale === 'en-US'">{{
                item.category.nameEn
              }}</span>
            </div>
            <router-link :to="`/newsview?id=${item.id}`">
              <span class="card_new_span_l" v-if="$i18n.locale === 'uz-UZ' || $i18n.locale === 'uz-QR'">{{
                resolveUzQrValue(item, ["titleQrq", "titleUzQr"], "titleUzLat")
              }}</span>
              <span class="card_new_span_l" v-if="$i18n.locale === 'uz-CYR'">{{
                item.titleUz
              }}</span>
              <span class="card_new_span_l" v-if="$i18n.locale === 'ru-RU'">{{
                item.tilteRu
              }}</span>
              <span class="card_new_span_l" v-if="$i18n.locale === 'en-US'">{{
                item.titleEn
              }}</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="py-3">
        <div class="card card-lift shadow border-0 card-img_tab_card_diag">
          <h5 class="card_new_title">{{ $t("homepage.diag") }}</h5>
          <div>
            <span class="card_diag_text">{{ $t("homepage.statistic") }}</span>
            <el-row :gutter="10">
              <el-col class="py-2" :span="8">
                <div class="card card-lift border-1 card-diag_info">
                  <h2 class="card_diag_number">{{formatNumber(JAMI_MUROJAAT)}}</h2>
                  <span class="card_diag_span_w vertical-center">{{
                    $t("homepage.statistic1")
                  }}</span>
                </div>
              </el-col>
              <el-col class="py-2" :span="8">
                <div class="card card-lift border-1 card-diag_info">
                  <h2 class="card_diag_number">{{formatNumber(KURIB_CHIQILGAN)}}</h2>
                  <span class="card_diag_span_w vertical-center">{{
                    $t("homepage.statistic2")
                  }}</span>
                </div>
              </el-col>
              <el-col class="py-2" :span="8">
                <div class="card card-lift border-1 card-diag_info">
                  <h2 class="card_diag_number">{{formatNumber(JARAYONDA)}}</h2>
                  <span class="card_diag_span_w vertical-center">{{
                    $t("homepage.statistic3")
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </div>
          <div>
            <span class="card_diag_text">{{TITLE_1}}</span>
            <div id="chart" style="height: 135px;">
              <apexchart
                type="pie"
                width="390"
                style="min-height: 135px!important; max-height: 150px!important;"
                :options="chartOptions"
                :series="series"
              />
            </div>
            <!--                        <router-link class="text_link_new" to="/">-->
            <!--                            <span>{{$t('homepage.statistic6')}} <i class="fa fa-angle-right"></i></span>-->
            <!--                        </router-link>-->

            <span class="card_diag_text">{{TITLE_2}}</span>
            <div id="chart1" style="height: 135px;">
              <apexchart
                type="pie"
                width="370"
                style="min-height: 135px!important; max-height: 150px!important;"
                :options="chartOptions1"
                :series="series1"
              />
            </div>
            <!--                        <router-link class="text_link_new" to="/">-->
            <!--                            <span>{{$t('homepage.statistic6')}} <i class="fa fa-angle-right"></i></span>-->
            <!--                        </router-link>-->
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import moment from "moment";

export default {
  name: "MainPagePanel1",
  data() {
    return {
      TITLE_1: null,
      TITLE_2: null,
      JAMI_MUROJAAT: 0,
      KURIB_CHIQILGAN: 0,
      HUQUQI_TIKLANGAN: 0,
      JAMI_QABUL: 0,
      SAYYOR_VA_OMMAVIY: 0,
      JARAYONDA: 0,
      lastNews: [],
      currentNews: null,
      selectedComponent: null,
      selectedRegion: 37,
      regionCodes: {
        26: this.$t("homepage.regions"),
        27: this.$t("homepage.regions1"),
        28: this.$t("homepage.regions2"),
        29: this.$t("homepage.regions3"),
        30: this.$t("homepage.regions4"),
        31: this.$t("homepage.regions5"),
        32: this.$t("homepage.regions6"),
        33: this.$t("homepage.regions7"),
        34: this.$t("homepage.regions8"),
        35: this.$t("homepage.regions9"),
        36: this.$t("homepage.regions10"),
        37: this.$t("homepage.regions11"),
        38: this.$t("homepage.regions12"),
        39: this.$t("homepage.regions13")
      },
      regionData: {
        26: [
          {
            photo: "img/viloyat_pro/Андижон.jpg",
            tel: "0374 227-10-07",
            fax: "0374 227-10-07",
            address: "prokuraturaTizimi.hudud_manzil1",
            orientir: '"Andijan"'
          }
        ],
        27: [
          {
            photo: "img/viloyat_pro/Бухоро.jpg",
            tel: "0365 221-10-07",
            fax: "0365 221-10-07",
            address: "prokuraturaTizimi.hudud_manzil2",
            orientir: '"Бухоро вилояти"'
          }
        ],
        28: [
          {
            photo: "img/viloyat_pro/жиззах.jpg",
            tel: "0372 226-10-07",
            fax: "0372 226-10-07",
            address: "prokuraturaTizimi.hudud_manzil3",
            orientir: '"Жиззах вилояти"'
          }
        ],
        29: [
          {
            photo: "img/viloyat_pro/Қашқадарё.jpg",
            tel: "0375 228-10-07",
            fax: "0375 228-10-07",
            address: "prokuraturaTizimi.hudud_manzil4",
            orientir: '"Қашқадарё вилояти"'
          }
        ],
        30: [
          {
            photo: "img/viloyat_pro/qoraqalpoq.jpg",
            tel: "0361 222-10-07",
            fax: "0361 222-10-07",
            address: "prokuraturaTizimi.hudud_manzil5",
            orientir: '"Қорақалпоғистон Республикаси"'
          }
        ],
        31: [
          {
            photo: "img/viloyat_pro/навоий.jpg",
            tel: "0436 210-10-07",
            fax: "0436 210-10-07",
            address: "prokuraturaTizimi.hudud_manzil6",
            orientir: '"Навоий вилояти"'
          }
        ],
        32: [
          {
            photo: "img/viloyat_pro/Наманган.jpg",
            tel: "0369 227-10-07",
            fax: "0369 227-10-07",
            address: "prokuraturaTizimi.hudud_manzil7",
            orientir: '"Наманган вилояти"'
          }
        ],
        33: [
          {
            photo: "img/viloyat_pro/Самарқанд.jpg",
            tel: "0366 232-10-07",
            fax: "0366 232-10-07",
            address: "prokuraturaTizimi.hudud_manzil8",
            orientir: '"Самарқанд вилояти"'
          }
        ],
        34: [
          {
            photo: "img/viloyat_pro/sirdaryo.jpg",
            tel: "0367 235-10-07",
            fax: "0367 235-10-07",
            address: "prokuraturaTizimi.hudud_manzil9",
            orientir: '"Сирдарё вилояти"'
          }
        ],
        35: [
          {
            photo: "img/viloyat_pro/Сурхондарё.jpg",
            tel: "0376 223-10-07",
            fax: "0376 223-10-07",
            address: "prokuraturaTizimi.hudud_manzil10",
            orientir: '"Сурхондарё вилояти"'
          }
        ],
        36: [
          {
            photo: "img/viloyat_pro/toshvil.jpg",
            tel: "0371 230-10-07",
            fax: "0371 230-10-07",
            address: "prokuraturaTizimi.hudud_manzil11",
            orientir: '"Тошкент вилояти"'
          }
        ],
        37: [
          {
            photo: "img/viloyat_pro/Тошкент шаҳар.jpg",
            tel: "0371 271-10-07",
            fax: "0371 271-10-07",
            address: "prokuraturaTizimi.hudud_manzil12",
            orientir: '"Тошкент шаҳри"'
          },
          {
            photo: "img/viloyat_pro/Бюро.jpg",
            tel: "0371 207-11-59",
            fax: "0371 207-11-59",
            address: "prokuraturaTizimi.hudud_manzil13",
            orientir: '"Мажбурий ижро Бюроси"'
          },
          {
            photo: "img/viloyat_pro/harbiy.jpg",
            tel: "0371 232-01-71",
            fax: "0371 232-01-71",
            address: "prokuraturaTizimi.hudud_manzil14",
            orientir: '"Ўзбекистон Республикаси Ҳарбий прокуратураси"'
          },
          {
            photo: "img/viloyat_pro/департамент.jpg",
            tel: "0371 233-10-07",
            fax: "0371 233-10-07",
            address: "prokuraturaTizimi.hudud_manzil15",
            orientir: '"Бош прокуратура ҳузуридаги Департамент"'
          },
          {
            photo: "img/viloyat_pro/transport.jpg",
            tel: "0371 299-94-00",
            fax: "0371 299-94-00",
            address: "prokuraturaTizimi.hudud_manzil16",
            orientir: '"Ўзбекистон Республикаси Транспорт прокуратураси"'
          }
        ],
        38: [
          {
            photo: "img/viloyat_pro/Фарғона.jpg",
            tel: "0373 244-10-07",
            fax: "0373 244-10-07",
            address: "prokuraturaTizimi.hudud_manzil17",
            orientir: '"Фарғона вилояти"'
          }
        ],
        39: [
          {
            photo: "img/viloyat_pro/хоразм.jpg",
            tel: "0362 227-10-07",
            fax: "0362 227-10-07",
            address: "prokuraturaTizimi.hudud_manzil18",
            orientir: '"Хоразм вилояти"'
          }
        ]
      },
      series: [0, 0, 0],
      chartOptions: {
        labels: [
          this.$t("homepage.statistic7"),
          this.$t("homepage.statistic8"),
          this.$t("homepage.statistic9")
        ],
        dataLabels: {
          enabled: true,
          formatter: function(val, opt) {
            let {seriesIndex, w: {config: {series}}} = opt;
            return series[seriesIndex];
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 380,
                height: 135
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      },
      series1: [0, 0],
      chartOptions1: {
        labels: [
          this.$t("homepage.statistic10"),
          this.$t("homepage.statistic11")
        ],
        dataLabels: {
          enabled: true,
          formatter: function(val, opt) {
            let {seriesIndex, w: {config: {series}}} = opt;
            return series[seriesIndex];
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 370,
                height: 135
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      },
      images: [
        "img/gallery/rasm0.jpg",
        "img/gallery/rasm1.jpg",
        "img/gallery/rasm2.jpg",
        "img/gallery/rasm3.jpg",
        "img/gallery/rasm4.jpg",
        "img/gallery/rasm6.jpg",
        "img/gallery/rasm8.jpg",
        "img/gallery/rasm9.jpg",
        "img/gallery/rasm10.jpg",
        "img/gallery/rasm11.jpg"
      ],
    };
  },
  watch: {
    "$store.state.locale": function() {
      this.changeChartOptions();
      this.changeMapRegionNmae();
    }
  },
  methods: {
    formatNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    changeChartOptions() {
      // let lang = this.$i18n.locale;
      this.chartOptions = {
        labels: [
          this.$t("homepage.statistic7"),
          this.$t("homepage.statistic8"),
          this.$t("homepage.statistic9")
        ]
      };
      this.chartOptions1 = {
        labels: [
          this.$t("homepage.statistic10"),
          this.$t("homepage.statistic11")
        ]
      };
    },
    changeMapRegionNmae() {
      this.regionCodes = {
        26: this.$t("homepage.regions"),
        27: this.$t("homepage.regions1"),
        28: this.$t("homepage.regions2"),
        29: this.$t("homepage.regions3"),
        30: this.$t("homepage.regions4"),
        31: this.$t("homepage.regions5"),
        32: this.$t("homepage.regions6"),
        33: this.$t("homepage.regions7"),
        34: this.$t("homepage.regions8"),
        35: this.$t("homepage.regions9"),
        36: this.$t("homepage.regions10"),
        37: this.$t("homepage.regions11"),
        38: this.$t("homepage.regions12"),
        39: this.$t("homepage.regions13")
      };
    },
    onDateChange(selectedDate) {
      if (selectedDate) {
        this.$axios
          .get(
            `https://www.prokuratura.uz/api/news/page/category-and-date/1?page=0&date=${selectedDate}`
          )
          .then(response => {
            this.lastNews = response.data.content;
            if (this.lastNews.length > 0) {
              this.currentNews = this.lastNews[0];
            }
          });
      } else {
        this.$axios
          .get(`https://www.prokuratura.uz/api/news/last-news?size=8`)
          .then(response => {
            this.lastNews = response.data.content;
            this.currentNews = this.lastNews[0];
          });
      }
    },
    onRegionSelect(ids) {
      if (this.selectedRegion !== ids[0]) {
        this.selectedRegion = ids[0];
        // this.counts.prosecutors = Math.floor(Math.random() * 3);
        // this.counts.department = Math.floor(Math.random() * 2);
        // this.counts.bureau = Math.floor(Math.random() * 2);
        // this.counts.inspectorate = Math.floor(Math.random() * 3);
      } /*else {
                this.selectedRegion = -1;
            }*/
    },
    parseDate(dateTime) {
      return moment(dateTime).format("DD.MM.YYYY");
    },
    carouselChange(index) {
      this.currentNews = this.lastNews[index];
    },
    getImageToSlider(imageUrls) {
      if (!imageUrls || imageUrls.length === 0) {
        return [[]];
      }
      let resArr = [];
      let childItemRes = [];
      imageUrls.forEach(item => {
        childItemRes.push(item);
        if (childItemRes.length === 3) {
          resArr.push(childItemRes);
          childItemRes = [];
        }
      });
      return resArr;
    },
    resolveUzQrValue(item, qrKeys, fallbackKey) {
      const value = qrKeys.map(key => item && item[key]).find(Boolean);
      return value || (item && item[fallbackKey]) || "";
    },
    getLangCode(){
      var lang;
      switch(this.$i18n.locale){
        case "uz-UZ":
        case "uz-QR":
          lang = "UZB_LAT";
          break;
        case "uz-CYR":
          lang = "UZB_CYR";
          break;
        case "ru-RU":
          lang = "RU";
          break;
        case "en-US":
          lang = "ENG";
          break;
      }
      return lang;
    }
  },
  mounted() {
    this.selectedComponent = "MainPagePanel1";
  },
  created() {
    // this.$axios.get(`http://172.18.45.189:8080/api/news/last-news?size=8`).then(response => {
    this.$axios
      .get(`https://www.prokuratura.uz/api/news/last-news?size=8`)
      .then(response => {
        this.lastNews = response.data.content;
        this.currentNews = this.lastNews[0];
      });

    this.$axios
        .get(`https://prokuratura.uz/api/murojaat-stats-for-web-page`)
        .then(response => {
          this.JAMI_MUROJAAT = response.data.find(x => x.id === 1).value;
          this.KURIB_CHIQILGAN = response.data.find(x => x.id === 2).value;
          this.HUQUQI_TIKLANGAN = response.data.find(x => x.id === 4).value;
          this.JAMI_QABUL = response.data.find(x => x.id === 5).value;
          this.SAYYOR_VA_OMMAVIY = response.data.find(x => x.id === 6).value;
          this.JARAYONDA = response.data.find(x => x.id === 3).value;
          this.series = [this.JAMI_MUROJAAT, this.KURIB_CHIQILGAN, this.HUQUQI_TIKLANGAN];
          this.series1 = [this.JAMI_QABUL, this.SAYYOR_VA_OMMAVIY]
          this.TITLE_1 = response.data.find(x => x.type === "TITLE_1_" + this.getLangCode()).name;
          this.TITLE_2 = response.data.find(x => x.type === "TITLE_2_" + this.getLangCode()).name;
        });
  }
};
</script>
<style scoped>
@import url(../../../assets/css/custom.scss);

hr {
  border: none;
  border-left: 1px solid #00b0f0;
  height: 14px;
  margin: 4px 5px;
  width: 1px;
}

blockquote {
  margin: 0 0 0rem;
}

.button_new_m {
  display: block;
  white-space: inherit;
  line-height: 1;
  font-weight: 500;
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: transparent;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: transparent;
}

.st1 {
  fill: #96b4d3;
  stroke: #fff;
  stroke-miterlimit: 10;
}

.st1:hover {
  fill: #04ad00;
  cursor: pointer;
}

.st1.active {
  fill: #21ad69;
}
/deep/ .apexcharts-legend.apexcharts-align-center.position-right {
  width: 70%;
}
</style>
